import { themeStyle } from '@repo/ui/theming';

export const CoverHeadline = 'What do you want to create?';

export const CoverUnauthorisedLibraryHeadline = 'Free templates';

export const CoverUnauthorisedLibraryDescription =
  "Discover Kittl's collection of beautiful free templates. Customize effortlessly with drag-and-drop, creating perfect designs for any occasion in a snap.";

export const CoverUnauthorisedUseCaseHeadline = (useCase: string) =>
  `${useCase} templates`;

export const UploadButtonTheme = {
  name: null,
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  backgroundColorDark: 'rgba(255, 255, 255, 0.1)',
  borderColor: 'rgba(255, 255, 255, 0.3)',
  borderColorDark: 'rgba(255, 255, 255, 0.3)',
  backgroundActiveColor: 'rgba(255, 255, 255, 0.2)',
  backgroundActiveColorDark: 'rgba(255, 255, 255, 0.2)',
  borderActiveColor: 'rgba(255, 255, 255, 0.2)',
  borderActiveColorDark: 'rgba(255, 255, 255, 0.2)',
  color: themeStyle.backgroundAlt,
  colorDark: themeStyle.backgroundAlt,
};

export const commonInputTheme = {
  width: '100%',
  fontSize: themeStyle.fontSize14,
  innerPadding: '12px',
  boxShadow: themeStyle.shadowMedium,
};
